<template>
    <div class="rankdetail">
      <div class="jjxq-con">
        <div>
            <div class="title jjxqtext"></div>
            <div class="detailcontent">
              <div class="infodetail">
                <div class="otherinfo">
                  <div class="glr">
                    <span class="fundname">{{ productInfo.productName }}</span>
                    <span class="times">
                      参赛时间：<span>{{ productInfo.initDate }}</span>
                    </span>
                  </div>
                </div>
                <div id="charts"></div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import echarts from "echarts";
  import { http } from "../fetch/api";
  export default {
    data() {
      return {
        productInfo: {},
        name: "参赛净值",
        activeTab: "ljdwjz",
        seriesData: []
      };
    },
    mounted() {
      this.getInfo();
    },
    methods: {
     
      showchart() {
        var myChart = echarts.init(document.getElementById("charts"));
        myChart.clear();
        myChart.setOption({
          title: {
            text: ""
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross"
            },
            formatter: function(params) {
              let ccjz = params[0]
              let ljjz = params[1]
                return (
                  "<div>" +
                  ccjz.axisValue +
                  "<br>" +
                  ccjz.marker +
                  ccjz.seriesName +
                  ":" +
                  ccjz.value +
                  "<br>" +
                  ljjz.marker +
                  "累计净值" +
                  ":" +
                  ljjz.value +
                  "</div>"
                )
            }
          },
          legend: {
            data: [this.name]
          },
          xAxis: {
            data: this.productInfo.recordDates
          },
          yAxis: {
            scale:true
          },
          series: [
            {
              name: this.name,
              type: "line",
              data: this.seriesData.csjz
            },
            {
              name: this.name,
              type: "line",
              data: this.seriesData.ljjz,
              symbol: "none", // 去除小圆点
              lineStyle: {width: 0,color: 'rgba(0, 0, 0, 0)'}, //隐藏线
            }
          ]
        });
      },
      async getInfo() {
        var data = await http.proSeries(
          this.$route.query.productId
        );
        this.productInfo = data.data;
        this.seriesData = this.productInfo;
        this.showchart();
      }
    }
  };
  </script>
  <style scoped>  
  .jjxq-con > div {
    padding: 50px 0;
    width: 1200px;
    margin: 0 auto;
  }
  .title {
    height: 67px;
    line-height: 67px;
    text-align: center;
    font-size: 30px;
    letter-spacing: 5px;
    margin: 0 auto 35px auto;
    background-repeat: no-repeat;
    background-size: 750px;
    background-position: center;
  }
  .title span {
    padding-left: 50px;
    display: inline-block;
    background-image: -webkit-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: -o-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: -moz-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: linear-gradient(73deg, #0c3b95, #cf5860);
    -webkit-background-clip: text;
    -o-background-clip: text;
    -ms-background-clip: text;
    -moz-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    -o-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
    text-fill-color: transparent;
    font-weight: bold;
  }
  .jjxqtext {
    background-image: url("../assets/lsda.png");
  }
  .detailcontent {
    padding-top: 0;
    height: 572px;
    background-size: contain;
    background-image: url("../assets/bluefile.png");
    background-repeat: no-repeat;
  }
  .name {
    margin-top: 20px;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    line-height: 22px;
    letter-spacing: 1.6px;
    color: #0d225c;
  }
  .infodetail {
    vertical-align: top;
    display: inline-block;
    width: 100%;
    height: 100%;
  }
  .otherinfo {
    margin-top: 30px;
  }
  .otherinfo > div {
    display: inline-block;
    width: 100%;
  }
  .glr {
    padding-left: 30px;
    box-sizing: border-box;
    position: relative;
  }
  .times {
    box-sizing: border-box;
    position: absolute;
    right: 30px;
  }
  .times > div {
    display: inline-block;
    margin-left: 20px;
  }
  
  #charts {
    height: 470px;
    margin-top: 30px;
  }
  .fundname {
    color: #6D000E;
    font-weight: bold;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/bluefile.vue